import classNames from "classnames";
import styles from "./error.module.scss";
import Image from "next/image";
import NavBar from "@/components/common/NavBar";
import Footer from "@/components/common/Footer";
import CitiesOperated from "@/components/common/CitiesOperated";
import Seo from "@/components/common/seo";
import { useRouter } from "next/router";
import { BASEURL } from "@/utils/baseUrl";
const Custom404 = () => {
  const router = useRouter();
  return (
    <>
      <Seo
        title={"Oops, Page not found"}
        description={"We seem to have come across an error!"}
        heading={"We seem to have come across an error!"}
        url={`${BASEURL}/${404}`}
      />
      <NavBar />
      <div className={styles["container"]}>
        <Image
          width={308}
          height={224}
          className={styles["mb-44"]}
          src={"/svgs/404_image.svg"}
          alt="404 image"
        />
        <h1
          className={classNames(
            styles["large_title"],
            styles["white1"],
            styles["mb-18"]
          )}
        >
          Oops, Page not found!
        </h1>
        <p
          className={classNames(
            styles["sub"],
            styles["font18"],
            styles["white3"]
          )}
        >
          We seem to have come across an error!
        </p>
      </div>
      {/* <CitiesOperated reload /> */}
      <Footer />
    </>
  );
};

export default Custom404;
